export default "__VITE_ASSET__Dz9RwvG9__"